import { useMemo } from 'react';

const CSV_TEMPLATE = [
  [
    'Campaign (optional)',
    'Subject',
    'Email Body',
    'Sent',
    'Delivered',
    'Opened',
    'Clicked',
    'Date\n',
  ],
  [
    'Campaign name',
    'Paste the subject line of the email here',
    'Paste the content of your email here',
    '100000',
    '9000',
    '4640',
    '119',
    '2023-07-27 12:33:47\n',
  ],
  [
    'Campaign name',
    'Paste the subject line of the email here',
    'Paste the content of your email here',
    '100000',
    '9000',
    '4640',
    '119',
    '2023-07-27 12:33:47\n',
  ],
];

// Creating an object for downloading url
export const useCsvTemplateUrl = () => {
  return useMemo(() => {
    const blob = new Blob(CSV_TEMPLATE, { type: 'text/csv' });
    return window.URL.createObjectURL(blob);
  }, []);
};
